module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/avatar2-d9882d35ba0e534cba9f87c1dd2bb9d6.png";